'use strict';



$('.learn-more-link').on('click', function() {
	$(this).parents('.copy-container').find('.bullet-list').fadeIn();
	$(this).fadeOut('fast');
	$(this).parents('.copy-container').find('.icon-chevron-right-thin').fadeOut('fast');
});
